import { useOverlayContext } from 'seagull';
import { MapServicesModal } from "./MapServicesModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const useOpenMapServicesModal = (serviceTemplateIds, reload) => {
  const overlayContext = useOverlayContext();
  return async function openMapServicesModal(accounting) {
    if (!serviceTemplateIds.length) {
      overlayContext.showErrorToast('An error occurred. ', 'no-services-to-map-toast');
      return;
    }
    await overlayContext.showModal({
      closeOnClickOutside: false,
      closeOnEscapeKey: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(MapServicesModal, {
          accounting: accounting,
          dismissModal: dismissModal,
          serviceTemplateIds: serviceTemplateIds,
          onChange: reload
        });
      }
    });
  };
};